import { config as base } from '@giscube/geoportal'
import AdvancedSearch from 'src/lib/AdvancedSearch'

export default base.merge({
  basemaps: [
    {
      default: true,
      type: 'tilelayer',
      name: 'Mapa base de fons',
      url: 'https://atilemaps.icgc.cat/mapfactory/wmts/topo_suau/CAT3857/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="https://www.icgc.cat">ICGC</a>',
      maxNativeZoom: 18,
      maxZoom: 22
    },
    {
      type: 'tilelayer',
      name: 'OpenStreetMap',
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxNativeZoom: 18,
      maxZoom: 22
    },
    {
      type: 'tilelayer',
      name: 'OpenStreetMap (Grey)',
      url: 'http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxNativeZoom: 18,
      maxZoom: 22
    },
    {
      type: 'tilelayer',
      name: 'Mapa base de fons (gris)',
      url: 'https://ctilemaps.icgc.cat/mapfactory/wmts/gris_topo_suau/CAT3857/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="https://www.icgc.cat">ICGC</a>',
      maxNativeZoom: 18,
      maxZoom: 22
    },
    {
      type: 'tilelayer',
      name: 'Topogràfic (ICGC)',
      url: 'https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/topo/GRID3857/{z}/{x}/{y}.jpeg',
      attribution: '&copy; <a href="https://www.icgc.cat">ICGC</a>',
      maxNativeZoom: 18,
      maxZoom: 22
    },
    {
      type: 'tilelayer',
      name: 'Ortoimatge (ICGC)',
      url: 'https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.jpeg',
      attribution: '&copy; <a href="https://www.icgc.cat">ICGC</a>',
      maxNativeZoom: 20,
      maxZoom: 22
    },
    {
      type: 'tilelayer',
      name: 'Nit (ICGC)',
      url: 'https://btilemaps.icgc.cat/mapfactory/wmts/nit_topo_suau/CAT3857/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="https://www.icgc.cat">ICGC</a>',
      maxNativeZoom: 18,
      maxZoom: 22
    },
    {
      type: 'tilelayer',
      name: 'Sèpia (ICGC)',
      url: 'https://btilemaps.icgc.cat/mapfactory/wmts/sepia_topo_suau/CAT3857/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="https://www.icgc.cat">ICGC</a>',
      maxNativeZoom: 18,
      maxZoom: 22
    },
    {
      type: 'tilelayer',
      name: 'Carto DB',
      url: 'https://dnv9my2eseobd.cloudfront.net/v3/cartodb.map-4xtxp73f/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://mapbox.com/about/maps" target="_blank">Carto</a>',
      maxNativeZoom: 18,
      maxZoom: 22
    },
    {
      type: 'googleMutant',
      name: 'Roadmap Google',
      options: {
        type: 'roadmap'
      },
      maxNativeZoom: 18,
      maxZoom: 22
    },
    {
      type: 'googleMutant',
      name: 'Satellite Google',
      options: {
        type: 'satellite'
      },
      maxNativeZoom: 18,
      maxZoom: 22
    },
    {
      type: 'googleMutant',
      name: 'Hybrid Google',
      options: {
        type: 'hybrid'
      },
      maxNativeZoom: 18,
      maxZoom: 22
    },
    {
      type: 'googleMutant',
      name: 'Terrain Google',
      options: {
        type: 'terrain'
      },
      maxNativeZoom: 18,
      maxZoom: 22
    }
  ],
  branding: {
    header: {
      logo: require('assets/logo_mapiaonline.png'),
      text: 'Mapia Online',
      link: 'https://www.infraplan.cat/'
    }
  },
  catalog: {
    categories: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/geoportal/category/catalog/',
    search: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/geoportal/catalog/',
    base: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/',
    filter: require('../lib/filterCatalog').default,
    auth: true
  },
  defaultLayers: [
  ],
  editsources: [
  ],
  epsgs: [
    {
      label: 'Lat/Lon',
      code: 'EPSG:4326',
      def: '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees',
      format: ([x, y]) => `${y.toFixed(6)}°, ${x.toFixed(6)}°`
    },
    {
      label: 'UTM (ETRS89)',
      code: 'EPSG:25831',
      def: '+proj=utm +zone=31 +ellps=GRS80 +units=m +no_defs',
      format: ([x, y]) => `${x.toFixed(2)}m, ${y.toFixed(2)}m`
    }
  ],
  google: {
    apiKey: 'AIzaSyAQaku_EPfGFxbhecwF665h1PiHPSoJAtQ'
  },
  geoportalMap: {
    queryOnClick: require('components/QueryOnClick.vue').default
  },
  home: {
    zoom: 13,
    center: {
      lat: 41.155055,
      lng: 1.108731
    }
  },
  incidence: {
    url: 'https://streets.mapia-technologies.com/apps/giscube-admin/api/v2/giscube/incidence/'
  },
  layersControl: {
    itemPanel: false
  },
  layout: {
    headerToolbar: [
      'home',
      'catalog',
      'panorama',
      'streetview',
      'draw',
      '----------',
      'auth',
      {
        icon: 'settings',
        label: 'altres',
        items: [
          'search',
          '----------',
          'data',
          'addCustomLayer',
          'downloads',
          'share',
          'opendata',
          '----------',
          'language',
          'print',
          'fullscreen',
          '----------',
          'contact'
        ]
      }
    ],
    home: {
      homeIcon: 'menu',
      showCadastreBtn: true,
      baseLayerOptions: false,
      themes: [],
      tools: [
        'catalog',
        'panorama',
        'streetview',
        'draw',
        'search',
        'data',
        'downloads',
        'addCustomLayer',
        'cleanMap',
        'share',
        'print',
        'fullscreen',
        'contact'
      ]
    },
    mapPointZoom: 19,
    mapZoomPadding: 0.05,
    mapMaxFlyZoom: 19,

    sidebar: {
      initialWidthPercentage: 28,
      minWidthPixels: 300,
      minWidthPercentage: 24,
      steps: [24, 45, 60, 75]
    }
  },
  layoutBasic: {
    header: require('src/components/BasicLayout/AppHeader.vue').default
  },
  locale: {
    main: 'ca',
    fallback: 'en-us'
  },
  oauth: {
    type: 'password',
    client_id: 'b84uwJOlbtjeTAtThoazZFssE4RimQh3kyEiA8Z2',
    token: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/o/token/',
    revokeToken: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/o/revoke-token/',
    profile: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/geoportal/api/v1/profile/'
  },
  // searchEngine: CustomSearch,
  advancedSearchEngine: AdvancedSearch,
  advancedSearchConfig: {
    searchCatalog: true
  },
  searches: [
    {
      name: 'geoportal',
      title: 'Geoportal search',
      url: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/geoportal/search/',
      auth: true
    }
  ],
  tools: {
    addCustomLayer: {
      icon: 'las la-plus-circle',
      to: 'addcustomlayer'
    },
    cleanMap: {
      action () {
        const overlays = [...this.$store.state.map.layers.overlays]
        overlays.forEach(overlay => {
          const defaultLayers = this.$config.defaultLayers.map(layer => layer.id.plainRef)
          if (!defaultLayers.includes(overlay.id.plainRef)) {
            this.$store.dispatch('map/removeOverlay', overlay)
          }
        })
        this.$store.dispatch('map/removeSharedDrawings')
        this.$store.dispatch('map/removeMeasurements')
      }
    },
    data: {
      supported () {
        return !!this.$store.state.auth.username
      }
    },
    downloads: {
      icon: 'las la-file',
      to: 'downloads'
    },
    opendata: {
      icon: 'las la-universal-access',
      to: 'opendata'
    },
    language: {
      icon: 'g_translate',
      to: 'language'
    },
    panorama: {
      icon: 'panorama_horizontal',
      to: 'panorama',
      supported () {
        if (this.$config.panoramas.public) {
          return true
        } else {
          return !!this.$store.state.auth.username
        }
      }
    },
    search: {
      // icon: 'search',
      // to: 'search',
      // searchResultPopup: require('components/SearchResultPopup.vue').default
      // historyLength: 5
    },
    statistics: {
      enabled: true,
      groups: [
        // {
        //   name: 'Barris',
        //   url: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/layerserver/geojsonlayers/limits-barris'
        // },
        // {
        //   name: 'Seccions censals',
        //   url: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/layerserver/geojsonlayers/limits-oficials-seccionscensals'
        // },
        // {
        //   name: 'Col·legis electorals. Àmbits',
        //   url: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/layerserver/geojsonlayers/limits-oficials-colegiselectorals-ambits'
        // },
        // {
        //   name: 'Districtes electorals',
        //   url: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/layerserver/geojsonlayers/limits-oficials-districtes'
        // },
        // {
        //   name: 'Àrees bàsiques de Salut',
        //   url: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/layerserver/geojsonlayers/areas-basiques-salut'
        // }
      ]
    }
  },
  search_api: {
    // url: 'https://geoportal-demo.infraplan.cat/apps/giscube-admin/plugins/mapiareus_search/search/'
  },
  opendata_api: {
    url: 'https://opendata.reus.cat/api/3/action/'
  },
  panoramas: {
    horizontal: true,
    ambitsLayer: null,
    api: null,
    media: null,
    categories: null,
    color: null,
    epsg: null,
    movePointCloud: false,
    noImage: null,
    panoramasBoundary: null,
    panoramasLayer: null,
    panoramasPoints: null,
    pannellum: null,
    potree: null,
    radius: 15, // radi cerca API
    public: false
  },
  geocodificadorICGC: {
    title: 'Geocodificador ICGC',
    url: 'https://eines.icgc.cat/geocodificador/autocompletar',
    params: {
      size: 6
      // mun: '082055'
    }
  }
})
